module.exports = __webpack_public_path__ + "static/img/articleDetails-bg.dd4cf50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/articleDetails-bg.png
// module id = UUop
// module chunks = 1